import React, {Component} from "react"
import {connect} from "react-redux"
import AccountLogo from "../../../components/AccountLogo"
import {injectIntl} from 'react-intl'
import noLogoImage from '../../../images/neeuro_logo_square.jpg'
import {PATH_ENTERPRISE_LOGO_UPLOAD} from "../../../constants"
import ImageUploadModal from "../../../components/ImageUploadModal"

import {
  queryEnterpriseAccount
} from '../../../dispatch'


function mapStateToProps(state, ownProps) {

  const enterpriseAccount = state.enterpriseAccount
  const user = state.user

  return {
    enterpriseAccount, user
  }
}

const mapDispatchToProps = {
  queryEnterpriseAccount
}

class AccountLogoUploadImage extends Component {

  constructor() {
    super()
    this.state = {
      uploadImageModalOpen: false
    }

  }

  openModal = () => {
    this.setState({uploadImageModalOpen: true})
  }

  closeModal = () => {
    this.setState({uploadImageModalOpen: false})
  }

  render() {

    const intl = this.props.intl
    const format = intl.formatMessage

    if(!this.props.user.currentEnterpriseAccount) return (<div></div>)

    const accountId = this.props.user.currentEnterpriseAccount.id

    const logoPath = this.props.enterpriseAccount.logoPath ?
      this.props.enterpriseAccount.logoPath : noLogoImage

    return (
      <div className={` ${this.props.className}`} onClick={this.openModal}>

        <ImageUploadModal show={this.state.uploadImageModalOpen}
                          success={() => {
                            this.props.queryEnterpriseAccount(accountId)
                            this.closeModal()
                          }}
                          defaultImage={logoPath}
                          uploadPath={PATH_ENTERPRISE_LOGO_UPLOAD.replace(/{enterpriseAccountId}/, accountId)}
                          title={format({id: 'add.logo'})} onHide={this.closeModal}/>

        <div className="button-img m-sm">
          <AccountLogo
            size="lg"
            path={logoPath}/>
          <input className="btn btn-gray m-l-sm middle"
                 type="submit"
                 defaultValue={format({id: 'change.logo'})}/>
        </div>

      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AccountLogoUploadImage))



// WEBPACK FOOTER //
// ./src/routes/enterprise/components/AccountLogoUploadImage.js